<template lang="pug">
header.header_t#header_t_id(role='navigation' :class='[yScroll !== 0 || storeModalView ? "f-nav" : ""]')
  h1.header_logo
    a(@click='goToHome()')
      img(:src='require("../../assets/images/top_logo.png")' alt='home')
  .header_gnb_bg
    .gnb
      .menu#menu
        .major
          ul
            li.m1(:class='[overlapNav == "info" ? "pactive" : ""]')
              a(@click='$_goTo({name: "info"})')
                span(v-if="lan == 'kr'") 회사소개
                span(v-else) Company
            li.m2(:class='[overlapNav == "smart" ? "pactive" : ""]')
              a(@click='$_goTo({name: "smart"})')
                span Smart Brewery
            li.m3(:class='[overlapNav == "nano" ? "pactive" : ""]')
              a(@click='$_goTo({name: "nano"})')
                span Nano Brewery
            li.m4(:class='[overlapNav == "news" ? "pactive" : ""]')
              a(@click='$_goTo({name: "news"})')
                span NEWS
            li.m1(:class='[overlapNav == "store" ? "pactive" : ""]')
              a(@click='$_goTo({name: "store"})')
                span(v-if="lan == 'kr'") 설치매장
                span(v-else) Find INTHEKEG
            li.m1(:class='[overlapNav == "contact" ? "pactive" : ""]')
              a(@click='$_goTo({name: "contact"})')
                span CONTACT
  .h_lang
    ul
      li(:class='[lan == "kr" ? "on" : ""]')
        a(@click='selectCountry("kr")') KOR
      li(:class='[lan == "en" ? "on" : ""]')
        a(@click='selectCountry("en")') ENG
  .mo_nav(role='navigation' :class='[showMobileHeader ? "on" : ""]')
    .nav_in(@click='$emit("header-handler")')
      span.btn_t
      span.btn_m
      span.btn_b
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MobileHeader from './MobileHeader';
export default {
  components: {
    MobileHeader,
  },
  data() {
    return {};
  },
  props: ['yScroll', 'showMobileHeader', 'storeModalView'],
  computed: {
    ...mapGetters(['lan']),
    overlapNav() {
      let name = this.$route.name;
      if (name) {
        let nameArr = name.split('-');
        return nameArr[nameArr.length - 1];
      }
      return;
    },
  },
  methods: {
    ...mapActions(['getLang']),
    goToHome() {
      this.$_goTo({ name: 'home' });
      if (this.showMobileHeader) {
        this.$emit('header-handler');
      }
    },
    selectCountry(payload) {
      this.getLang(payload);
      let name = this.$route.name;
      this.$_goTo({ name: name.replace('en-', '') });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style>
@import '../../assets/css/common.css';
.top_nav {
  height: 90px;
}
</style>
